import { Money, MeasuredValue, SummaryInfo } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import * as reconciliationState from '../../_state/loadReconciliation.state';

export const LoadTotals = () => {
  const loadTotals = useAtomValue(reconciliationState.$loadTotals);

  return (
    <div className="@LoadTotals grid w-full grid-cols-6 gap-4">
      <SummaryInfo
        label="Net Shipped"
        primaryValue={<MeasuredValue {...loadTotals.netShippedWeight} />}
      />
      <SummaryInfo
        label="Net Received"
        primaryValue={<MeasuredValue {...loadTotals.netReceivedWeight} />}
      />
      <SummaryInfo
        label="Net Delta"
        primaryValue={<MeasuredValue {...loadTotals.netDeltaWeight} />}
      />
      <SummaryInfo
        label="Shipped load total"
        primaryValue={<Money value={loadTotals.shippedTotal} />}
      />
      <SummaryInfo
        label="Received load total"
        primaryValue={<Money value={loadTotals.receivedTotal} />}
      />
      <SummaryInfo
        label="Total Deductions"
        primaryValue={<Money value={loadTotals.deductionsTotal} />}
      />
    </div>
  );
};
